import { ContentSpinner } from '@taxbit-private/cosmic'
import * as React from 'react'
import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { useAuth } from 'contexts/auth/AuthContext'
import AuthRequired from 'contexts/auth/AuthRequired'
import useFeatureFlags from 'hooks/feature-flags/useFeatureFlags'
import { useInitializeVendorInfo } from 'vendors/useInitializeVendorInfo'

import AuthRequiredContent from './AuthRequiredContent'
import useApi from '../../api/useApi'
import { useUser } from '../../contexts/UserContext'

const App: React.FC = () => {
  const { loadUserWithFetcher } = useUser()
  const { fetch_current_user } = useApi()
  const { currentUser: currentAuthUser, isLoading: isAuthLoading } = useAuth()
  const { areFeatureFlagsLoaded } = useFeatureFlags()
  const navigate = useNavigate()
  const location = useLocation()
  const shouldAllowUnverifiedUser = !!import.meta.env.VITE_AUTH_UNVERIFIED_EMAIL_LOGIN

  const isInitialized = useInitializeVendorInfo()

  useEffect(() => {
    if (!isAuthLoading) {
      if (currentAuthUser) {
        if (!currentAuthUser.emailVerified && !shouldAllowUnverifiedUser) {
          navigate(`/login?requested=${location.pathname}`)
        } else {
          loadUserWithFetcher(fetch_current_user)
        }
      } else {
        navigate(`/login?requested=${location.pathname}`)
      }
    }
  }, [
    fetch_current_user,
    loadUserWithFetcher,
    currentAuthUser,
    navigate,
    location.pathname,
    isAuthLoading,
    shouldAllowUnverifiedUser,
  ])

  /**
   * We gate all UI based on the user & org being loaded because we
   * can't safely load all API data without them.
   */
  const isLoading = !areFeatureFlagsLoaded || !isInitialized

  return <AuthRequired>{isLoading ? <ContentSpinner /> : <AuthRequiredContent />}</AuthRequired>
}

export default App
